import { useState } from "react";
import { emptyString } from "../../../../constants";

const useModalDisplay = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalElement, setModalElement] = useState(emptyString);

  //To open the modal
  const openModal = () => {
    setShowModal(true);
  };

  //To close the modal
  const closeModal = () => {
    setShowModal(false);
  };

  //Setting modal component
  const setComponent = (component) => {
    setModalElement(component);
    openModal();
  };

  return [showModal, modalElement, setComponent, closeModal];
};

export default useModalDisplay;
